/**
 * Import custom GTM scripts here.
 *
 * @see {@link ./forms}
 */
import formStarts from './forms/_form-starts.js';
import formFails from './forms/_form-fails.js';

document.addEventListener('DOMContentLoaded', () => {
	formStarts();
	formFails();
});
